import {
  BaseRequestQueryParam,
  BetResponseModel,
  BetVoiceRequestBody,
  BetVoiceResponseModel,
  CopyBetRequestBody,
  GameResponseModel,
  HttpResponse,
  MatchTimeResponse,
  OddsRequest,
  OddsResponse,
  PlacingBetsRequestBody,
  PlacingComboBetRequestBody,
  PnLResponse,
  ShareBetRequestBody,
} from 'models';
import axiosClient, { handleRequest } from './axiosClient';
import { getLocalStorage } from 'utils/sessionStorage';
import { CancelToken } from 'axios';
import { CommentRequest } from 'models/comment';

const oddsApi = {
  getGames: (
    params: BaseRequestQueryParam,
    cancelToken: CancelToken,
  ): Promise<HttpResponse<GameResponseModel[]>> => {
    const url = `/terabet/api/games`;
    const token = getLocalStorage('access_token_terabet');

    const config = {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      params,
      cancelToken,
    };
    return handleRequest(axiosClient.get(url, config));
  },
  getOdds: (
    request: OddsRequest,
    cancelToken: CancelToken,
  ): Promise<HttpResponse<OddsResponse[]>> => {
    const url = `/terabet/api/games/get-odds`;
    const config = {
      cancelToken,
    };
    return handleRequest(axiosClient.post(url, request, config));
  },
  placingBets: (request: PlacingBetsRequestBody) => {
    const url = `/terabet/api/bets`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  placingComboBet: (request: PlacingComboBetRequestBody) => {
    const url = `/terabet/api/bets/combo`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  getBets: (
    params: BaseRequestQueryParam,
    cancelToken: CancelToken,
  ): Promise<HttpResponse<BetResponseModel[]>> => {
    const url = `/terabet/api/bets`;
    return handleRequest(
      axiosClient.get(url, {
        params,
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
        cancelToken,
      }),
    );
  },
  getBetsPnl: (): Promise<HttpResponse<PnLResponse>> => {
    const url = `/terabet/api/bets/pnl`;
    return handleRequest(
      axiosClient.get(url, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  getBetsATR: (): Promise<HttpResponse<PnLResponse>> => {
    const url = `/terabet/api/bets/atr`;
    return handleRequest(
      axiosClient.get(url, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  copyBets: (request: CopyBetRequestBody) => {
    const url = `/terabet/api/bets/copy`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  shareBets: (request: ShareBetRequestBody) => {
    const url = `/terabet/api/bets/share`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  voiceBet: (request: BetVoiceRequestBody): Promise<HttpResponse<BetVoiceResponseModel>> => {
    const url = `/terabet/api/bets/voices`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  pinGame: (gameId: string) => {
    const url = `/terabet/api/games/pin/${gameId}`;
    return handleRequest(
      axiosClient.post(url, null, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  commentGame: (body: CommentRequest) => {
    const url = `/terabet/api/comments`;
    return handleRequest(
      axiosClient.post(url, body, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  likeComment: (commentId: number) => {
    const url = `/terabet/api/comments/like/${commentId}`;
    return handleRequest(
      axiosClient.post(url, null, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  getComment: (gameId: string) => {
    const url = `/terabet/api/games/comments/${gameId}`;
    return handleRequest(
      axiosClient.get(url, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  getMatchTime: (fixtureId: string): Promise<HttpResponse<MatchTimeResponse>> => {
    const url = `/terabet/api/games/match/${fixtureId}`;
    return handleRequest(axiosClient.get(url));
  },
};

export default oddsApi;
